export const getId = (id: string) => `@@${id}`;
